//Test server
// const base_url = "http://3.86.165.70";
// export const image_url = "http://gps.odisoft.in/assets/images/vehicles/units";

// ---------------------->Live Server<---------------------
const base_url = "https://api.amcrestgps.net";
export const image_url = "https://amcrestgps.net/assets/images/vehicles/units";

export default base_url;
